import React from "react";
import "./TimelinessCompareBars.css";

// SLA status severity — reserved status palette, never cycled categorical
// hues (dataviz color-formula.md).
const slaColor = (pct) => (pct >= 90 ? "var(--an-good)" : pct >= 75 ? "var(--an-warning)" : "var(--an-critical)");

// Two side-by-side panels comparing all 3 Timeliness dashboards at once:
// relative % within SLA, and absolute within/outside counts (bar length
// scaled to each row's own volume so the busier dashboards read as busier).
// Rows double as tab triggers — clicking either panel's row for a dashboard
// selects it as the active detail below (kept in sync with `activeKey`).
const TimelinessCompareBars = ({ rows, activeKey, onSelectRow }) => {
  const maxTotal = Math.max(...rows.map((r) => r.withinCount + r.outsideCount), 1);

  const selectRow = (key) => onSelectRow && onSelectRow(key);
  const rowProps = (key) => ({
    className: `tl-compare-row${key === activeKey ? " tl-compare-row-active" : ""}`,
    role: onSelectRow ? "button" : undefined,
    tabIndex: onSelectRow ? 0 : undefined,
    onClick: () => selectRow(key),
    onKeyDown: (e) => {
      if (e.key === "Enter") selectRow(key);
    },
  });

  return (
    <div className="tl-compare-bars">
      <div className="tl-compare-panel">
        <h5 className="tl-compare-panel-title">% Within SLA</h5>
        {rows.map((r) => (
          <div key={r.key} {...rowProps(r.key)}>
            <span className="tl-compare-row-label">{r.label}</span>
            <div className="tl-compare-track">
              <div
                className="tl-compare-fill"
                style={{ width: `${Math.min(Math.max(r.withinPct, 0), 100)}%`, background: slaColor(r.withinPct) }}
              />
            </div>
            <span className="tl-compare-row-value">{r.withinPct.toFixed(0)}%</span>
          </div>
        ))}
      </div>

      <div className="tl-compare-panel">
        <h5 className="tl-compare-panel-title">Within vs Outside SLA (count)</h5>
        {rows.map((r) => {
          const total = r.withinCount + r.outsideCount;
          const widthPct = Math.max((total / maxTotal) * 100, total > 0 ? 6 : 0);
          const withinShare = total > 0 ? (r.withinCount / total) * 100 : 0;
          return (
            <div key={r.key} {...rowProps(r.key)}>
              <span className="tl-compare-row-label">{r.label}</span>
              <div className="tl-compare-track">
                <div className="tl-compare-track-bar" style={{ width: `${widthPct}%` }}>
                  <div className="tl-compare-fill-within" style={{ width: `${withinShare}%` }} />
                  <div className="tl-compare-fill-outside" style={{ width: `${100 - withinShare}%` }} />
                </div>
              </div>
              <span className="tl-compare-row-value">{r.withinCount} · {r.outsideCount}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TimelinessCompareBars;
